// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".drawerHeader-drawerHeader-JW6 {\n  height: 5rem;\n}\n\n.drawerHeader-closeWrapper-dHK {\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.drawerHeader-closeWrapper-dHK svg path {\n  stroke: var(--venia-global-color-white);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawerHeader": "drawerHeader-drawerHeader-JW6 bg-bronze flex items-center justify-center relative",
	"closeWrapper": "drawerHeader-closeWrapper-dHK"
};
export default ___CSS_LOADER_EXPORT___;
